import { hasOwn } from '@pexip/utils';
import { createConsoleLogger } from './baseLogger';
export let logger = createConsoleLogger();
export function setLogger(newLogger) {
    logger = newLogger;
}
export const isRedactable = (t) => {
    if (typeof t === 'string' && t) {
        return true;
    }
    return false;
};
/**
 * Registers T[K] for redaction when it is redactable, together with its
 * URL-encoded form, which URLs such as theme assets carry instead.
 */
export const redact = (t, k) => {
    if (t && hasOwn(t, k)) {
        const value = t[k];
        if (isRedactable(value)) {
            logger.addRedactPattern(value);
            const encoded = encodeURIComponent(value);
            if (encoded !== value) {
                logger.addRedactPattern(encoded);
            }
        }
    }
};
//# sourceMappingURL=logger.js.map